/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiProjectstatusesQueryResponse,
  GetApiProjectstatusesQueryParams,
} from '../models/GetApiProjectstatuses.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiProjectstatusesQueryResponseSchema } from '../zod/getApiProjectstatusesSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiProjectstatusesQueryKey = (
  params: GetApiProjectstatusesQueryParams,
) => [{ url: '/api/projectstatuses' }, ...(params ? [params] : [])] as const;

export type GetApiProjectstatusesQueryKey = ReturnType<
  typeof getApiProjectstatusesQueryKey
>;

/**
 * {@link /api/projectstatuses}
 */
export async function getApiProjectstatuses(
  params: GetApiProjectstatusesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectstatusesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/projectstatuses`,
    params,
    ...requestConfig,
  });
  return getApiProjectstatusesQueryResponseSchema.parse(res.data);
}

export function getApiProjectstatusesQueryOptions(
  params: GetApiProjectstatusesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectstatusesQueryKey(params);
  return queryOptions<
    GetApiProjectstatusesQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiProjectstatusesQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectstatuses(params, config);
    },
  });
}

/**
 * {@link /api/projectstatuses}
 */
export function useGetApiProjectstatuses<
  TData = GetApiProjectstatusesQueryResponse,
  TQueryData = GetApiProjectstatusesQueryResponse,
  TQueryKey extends QueryKey = GetApiProjectstatusesQueryKey,
>(
  params: GetApiProjectstatusesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectstatusesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiProjectstatusesQueryKey(params);

  const query = useQuery(
    {
      ...getApiProjectstatusesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
